export default class ReceiptPaymentDto {
    public id: string;
    public _d: number;
    public a: number;
}